import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useImpersonation } from '../context/ImpersonationContext';

const ImpersonationBanner = () => {
  const {
    isImpersonating,
    impersonatedCustomer,
    stopImpersonation,
  } = useImpersonation();

  const navigate = useNavigate();

  if (!isImpersonating) return null;

  const label = impersonatedCustomer?.name || impersonatedCustomer?.email || `#${impersonatedCustomer?.id}`;

  return (
    <div className="fixed bottom-0 left-0 w-full bg-amber-400 text-black text-center p-2 z-[9999] shadow-md">
      <span className="font-semibold">Admin accessing {label}</span>
      <button
        onClick={() => {
          stopImpersonation();
          navigate('/admin/access');
        }}
        className="ml-4 inline-flex items-center px-3 py-1 bg-black text-white rounded hover:bg-gray-800"
      >
        Exit admin access
      </button>
    </div>
  );
};

export default ImpersonationBanner; 